import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';
import {
  sortByDate,
} from './utils';

export const getVideos = order => createSelector(
  getResourceMappedList('videos', 'searchResults'),
  videos => videos.sort(sortByDate('created_at', order === 'oldest')),
);
